import FileUploaderV2ListItem from '@core/components/ApplyDialogV2/FileUploaderV2ListItem'
import React, { type FC } from 'react'
import './FileUploaderV2List.scss'

const baseClass = 'FileUploaderV2List'

interface FileUploaderV2ListProps {
    files: File[]
    fileErrors?: { file: File; error: string }[]
}

const FileUploaderV2List: FC<FileUploaderV2ListProps> = ({ fileErrors = [], files }) => {
    return (
        <div className={baseClass}>
            {files.map((file, index) => (
                <FileUploaderV2ListItem
                    key={index}
                    file={file}
                    fileError={fileErrors.find((err) => err.file === file)?.error}
                />
            ))}
        </div>
    )
}

export default FileUploaderV2List
